import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Box, Skeleton } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import { isSessionExpired, updateLastActivity } from "../contexts/AuthContext";

function PrivateRoute({ children }) {
  const { currentUser, loading, checkSessionAndLogout } = useAuth();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      if (currentUser) {
        // 先判断是否超过 7 天未访问，再顺延活动时间；否则先 update 会导致永不过期
        if (isSessionExpired()) {
          await checkSessionAndLogout();
          setIsChecking(false);
          return;
        }
        updateLastActivity();
      }
      setIsChecking(false);
    };

    // 如果 AuthContext 还在加载，等待它完成
    if (loading) {
      return;
    }

    checkSession();
  }, [currentUser, loading, checkSessionAndLogout]);

  // 显示骨架屏而不是白屏
  if (loading || isChecking) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100vh",
          bgcolor: "background.default",
        }}
      >
        {/* 顶部导航栏骨架 */}
        <Box
          sx={{
            width: "100%",
            height: 64,
            borderBottom: 1,
            borderColor: "divider",
            display: "flex",
            alignItems: "center",
            px: 2,
            gap: 2,
          }}
        >
          <Skeleton variant="rectangular" width={40} height={40} />
          <Skeleton variant="text" width={200} height={24} />
          <Box sx={{ flexGrow: 1 }} />
          <Skeleton variant="circular" width={40} height={40} />
        </Box>

        {/* 侧边栏和内容区域骨架 */}
        <Box sx={{ display: "flex", flex: 1 }}>
          {/* 侧边栏骨架 */}
          <Box
            sx={{
              width: 80,
              borderRight: 1,
              borderColor: "divider",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              py: 2,
              gap: 2,
            }}
          >
            {[1, 2, 3, 4, 5].map((i) => (
              <Skeleton key={i} variant="rectangular" width={48} height={48} />
            ))}
          </Box>

          {/* 主内容区域骨架 */}
          <Box sx={{ flex: 1, p: 3 }}>
            <Skeleton variant="text" width="40%" height={32} sx={{ mb: 2 }} />
            <Skeleton variant="rectangular" width="100%" height={400} />
          </Box>
        </Box>
      </Box>
    );
  }

  return currentUser ? children : <Navigate to="/login" />;
}

export default PrivateRoute;
